__turbopack_context__.v({
  "className": "ubuntu_a0a5d07-module__MJiYPW__className",
});
